var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCloseFilters(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 13.435,
    height: 13.435,
    viewBox: "0 0 13.435 13.435",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-1181.793 -188.793)"
  }, /*#__PURE__*/React.createElement("line", {
    x2: 12.021,
    y2: 12.021,
    transform: "translate(1182.5 189.5)",
    fill: "none",
    stroke: "#000",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    x1: 12.021,
    y2: 12.021,
    transform: "translate(1182.5 189.5)",
    fill: "none",
    stroke: "#000",
    strokeWidth: 2
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloseFilters);
export default __webpack_public_path__ + "static/media/close-filters.544022e59ef273945c2848df9266a72a.svg";
export { ForwardRef as ReactComponent };